import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isNullOrUndefined, isPresent } from 'utils'
import { useHistory, useParams } from 'react-router-dom'
import ChannelName from 'features/channel/add/part/ChannelName'
import SiteURL from 'features/channel/add/part/SiteURL'
import Account from 'features/channel/add/part/Account'
import TalkChannel from 'features/channel/add/part/TalkChannel'
import Category from 'features/channel/add/part/Category'
import Document from 'features/channel/add/part/Document'
import { reset } from 'features/channel/add/channelAddSlice'
import LoadingWrapper from 'components/loading/LoadingWrapper'
import { failWithErrorResponse } from 'features/toast/Toast'
import { getErrorMessage } from 'features/ErrorMessages'
import addChannel from 'features/channel/add/thunk/addChannel'
import requestReview from 'features/channel/add/thunk/requestReview'
import useChannelAddValidation from 'features/channel/add/hooks/useChannelAddValidation'
import useChannelAddReferrer, {
  CHANNEL_ADD_REFERRER,
} from 'features/channel/add/hooks/useChannelAddReferrer'
import PageHeader from '../../../components/PageHeader'
import Table from '../../../components/table/Table'
import Button from '../../../components/form/Button'
import BizChannelType from './part/BizChannelType'

const ChannelAdd = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { accountId } = useParams()
  const { bizChannelId, bizChannelType, reviewStatus, apiError, isLoading } =
    useSelector(state => state.channel.channelAdd)
  const {
    errors,
    validate,
    addError,
    addUnifiedUrlError,
    addMobileUrlError,
    addPcUrlError,
    clearError,
  } = useChannelAddValidation()
  const referrer = useChannelAddReferrer()

  const isExisting = isPresent(bizChannelId)
  const isEditable = !isExisting || reviewStatus === 'REJECTED_APPROVAL'

  useEffect(() => () => dispatch(reset()), [dispatch])
  useEffect(() => {
    clearError()
  }, [bizChannelType, clearError])
  useEffect(() => {
    console.log({ apiError })
    if (isNullOrUndefined(apiError)) return
    if (apiError.errorCode === 101002) {
      addError({ name: getErrorMessage(apiError) })
    } else {
      failWithErrorResponse(apiError)
    }
  }, [dispatch, apiError, addError])

  const handleCancel = useCallback(() => {
    if (referrer === CHANNEL_ADD_REFERRER.CAMPAIGN) {
      history.push(`/${accountId}/ads/campaigns/new`)
    } else if (referrer === CHANNEL_ADD_REFERRER.CREATIVE) {
      history.push(`/${accountId}/creatives/add`)
    } else if (referrer === CHANNEL_ADD_REFERRER.DOCUMENT) {
      history.push(`/${accountId}/documents/add`)
    } else {
      history.push(`/${accountId}/channels`)
    }
  }, [accountId, history, referrer])
  const handleConfirm = useCallback(async () => {
    try {
      await validate()
      const { error } = isExisting
        ? await dispatch(requestReview())
        : await dispatch(addChannel())
      if (!error) {
        if (referrer === CHANNEL_ADD_REFERRER.CAMPAIGN) {
          history.push(`/${accountId}/ads/campaigns/new`)
        } else if (referrer === CHANNEL_ADD_REFERRER.CREATIVE) {
          history.push(`/${accountId}/creatives/add`)
        } else if (referrer === CHANNEL_ADD_REFERRER.DOCUMENT) {
          history.push(`/${accountId}/documents/add`)
        } else {
          history.push(`/${accountId}/channels`)
        }
      }
    } catch (ignore) {}
  }, [validate, isExisting, dispatch, history, accountId, referrer])

  return (
    <LoadingWrapper isLoading={isLoading}>
      <div className="bizregister_wrap">
        <div className="dsp_tit">
          <PageHeader pageTitle="비즈채널 관리" />
        </div>
        <div className="ad_managebox">
          <div className="managebox_tit">
            <strong className="tit_box">비즈채널 등록</strong>
          </div>
          <Table className="tbl_g3" caption="비즈채널 등록 표">
            <Table.Head noHead>
              <Table.Column />
              <Table.Column />
            </Table.Head>
            <Table.Body>
              <BizChannelType />

              <ChannelName isEditable={isEditable} error={errors.name} />

              <SiteURL
                isEditable={isEditable}
                isExisting={isExisting}
                unifiedUrlError={errors.unifiedUrl || errors.unifiedUrlFormat}
                mobileUrlError={errors.mobileUrl || errors.mobileUrlFormat}
                pcUrlError={errors.pcUrl || errors.pcUrlFormat}
                unifiedUrlConnectionError={errors.unifiedUrlConnection}
                mobileUrlConnectionError={errors.mobileUrlConnection}
                pcUrlConnectionError={errors.pcUrlConnection}
                handleUnifiedUrlError={addUnifiedUrlError}
                handleMobileUrlError={addMobileUrlError}
                handlePcUrlError={addPcUrlError}
              />

              <Account
                isEditable={isEditable}
                hasAccessAccountError={errors.hasAccessAccount}
                accessAccountIdError={errors.accessAccountId}
                accessAccountPasswordError={errors.accessAccountPassword}
              />

              <TalkChannel
                isEditable={isEditable}
                error={errors.kakaoTalkChannel}
              />

              <Category
                isEditable={isEditable}
                selectedCategoryError={errors.selectedCategory}
                selectedCategoryDetailError={errors.selectedCategoryDetail}
              />

              <Document isEditable={isEditable} />
            </Table.Body>
          </Table>
        </div>
        <div className="page_btn">
          <div className="inner_btn">
            <Button onClick={handleCancel} size="big">
              취소
            </Button>
            <Button
              onClick={handleConfirm}
              size="big"
              primary
              disabled={!isEditable}>
              확인
            </Button>
          </div>
        </div>
      </div>
    </LoadingWrapper>
  )
}

export default ChannelAdd
